import React from 'react';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react';
import { getDisplayOrderType } from 'src/common/Order/utils';

export interface IOrderTypeProps {
  orderType: string;
  isGroupOrder: boolean;
}

export function OrderType({
  orderType,
  isGroupOrder,
}: IOrderTypeProps): JSX.Element {
  return (
    <Stack y="x-sm">
      <Copy variant="lead" color="secondaryText">
        {getDisplayOrderType({ isGroupOrder, orderType })} order from
      </Copy>
    </Stack>
  );
}
